import lib from '@/library'
import Vue from 'vue'

const state = {
  availableRPTypes: ['WIN', 'PLACE', 'SHOW', 'STRAIGHT'],
  availableRCTypes: ['EXACTA', 'TRIFECTA', 'SUPERFECTA', 'QUINELLA', 'SUPER HIGH 5'],
  availableMRTypes: ['DOUBLE', 'PICK3', 'PICK4', 'PICK5', 'GRANDSLAM', 'QUINDBL'],
  selectedWinRunners: {},
  selectedPlaceRunners: {},
  selectedShowRunners: {},
  selectedRCStraightRunners: [ {}, {}, {}, {} ],
  selectedRCBoxRunners: {},
  selectedRCKeyRunners: { key: {}, with: {} },
  selectedRCKeyBoxRunners: { key: {}, with: {} },
  selectedMRRunners: { },
  betslipType: '',
  stake: 0,
  calculatedBets: [],
  placeBetStatus: '',
  showBetSlip: false
}

const getters = {
  getAvailableRPTypes (state) {
    return state.availableRPTypes
  },
  getAvailableRCTypes (state) {
    return state.availableRCTypes
  },
  getAvailableMRTypes (state) {
    return state.availableMRTypes
  },
  getSelectedWinRunners (state) {
    return state.selectedWinRunners
  },
  getSelectedPlaceRunners (state) {
    return state.selectedPlaceRunners
  },
  getSelectedShowRunners (state) {
    return state.selectedShowRunners
  },
  getSelectedRCStraightRunners (state) {
    return state.selectedRCStraightRunners
  },
  getSelectedRCBoxRunners (state) {
    return state.selectedRCBoxRunners
  },
  getSelectedRCKeyRunners (state) {
    return state.selectedRCKeyRunners
  },
  getSelectedRCKeyBoxRunners (state) {
    return state.selectedRCKeyBoxRunners
  },
  getSelectedMRRunners (state) {
    return state.selectedMRRunners
  },
  getNumberOfWinPlaceLines (state) {
    return Object.keys(state.selectedWinRunners).length + Object.keys(state.selectedPlaceRunners).length + Object.keys(state.selectedShowRunners).length
  },
  getStake (state) {
    return state.stake
  },
  getBetslipType (state) {
    return state.betslipType
  },
  getCalculatedBets (state) {
    return state.calculatedBets
  },
  getPlaceBetStatus (state) {
    return state.placeBetStatus
  },
  getShowBetSlip (state) {
    return state.showBetSlip
  }
}

const actions = {
  toggleSelectedRunner (context, request) {
    // request
    //   idtgpooltype - WIN, PLACE, DOUBLE...
    //   idtgpoolcategory - RUNNER POOL, RACECAST POOL, MULTIRACE POOL
    //   idtgrace - race id
    //   runner - runner objct
    //   pool - pool object
    //   type - STRAIGHT, BOX, KEY, KEYBOX
    //   order - KEY, WITH

    this.state.betslipState.betslipType = request.type || 'STRAIGHT'

    switch (request.idtgpoolcategory) {
      case 'RUNNER POOL': {
        switch (request.idtgpooltype) {
          case 'WIN': {
            context.commit('toggleSelectedWinRunners', request.runner)
            break
          }
          case 'PLACE': {
            context.commit('toggleSelectedPlaceRunners', request.runner)
            break
          }
          case 'SHOW': {
            context.commit('toggleSelectedShowRunners', request.runner)
            break
          }
        }
        break
      }
      case 'RACECAST POOL': {
        switch (request.type) {
          case 'STRAIGHT': {
            context.commit('toggleSelectedRCStraightRunners', { runner: request.runner, order: request.order })
            break
          }
          case 'BOX': {
            context.commit('toggleSelectedRCBoxRunners', request.runner)
            break
          }
          case 'KEY': {
            context.commit('toggleSelectedRCKeyRunners', { runner: request.runner, order: request.order })
            break
          }
          case 'KEYBOX': {
            context.commit('toggleSelectedRCKeyBoxRunners', { runner: request.runner, order: request.order })
            break
          }
        }
        break
      }
      case 'MULTIRACE POOL': {
        context.commit('toggleSelectedMRRunners', request)
        break
      }
    }

    this.dispatch('betslipState/calculateBetSlip', request)
  },
  toggleBetslip (context) {
    context.commit('toggleBetslip')
  },
  getPreparedWinPLaceBets (context) {
    var tgBets = []
    var winLegs = []
    var placeLegs = []
    var showLegs = []
    var winIdTgPoolOffer
    var placeIdTgPoolOffer
    var showIdTgPoolOffer
    var toteRp = this.getters['raceState/getRaceRp']
    var selectedWinRunners = this.getters['betslipState/getSelectedWinRunners']
    var selectedPlaceRunners = this.getters['betslipState/getSelectedPlaceRunners']
    var selectedShowRunners = this.getters['betslipState/getSelectedShowRunners']
    var numberOfWinPlaceLines = this.getters['betslipState/getNumberOfWinPlaceLines']

    if (numberOfWinPlaceLines) {
      winLegs = []
      placeLegs = []
      showLegs = []

      Object.keys(selectedWinRunners).forEach(key => {
        if (selectedWinRunners[key]) {
          var runner = selectedWinRunners[key]

          winLegs.push({
            'IDTGRunner': runner.idtgrunner,
            'MeetingNumber': toteRp.meeting.number,
            'RaceNumber': toteRp.race.number,
            'RunnerNumber': runner.number,
            'RunnerName': runner.name,
            'IsFavourite': false,
            'IsField': false,
            'IsBanker': false,
            'LegOrder': 0,
            'Runner2FinishPlace': 0,
            'PoolLegNumber': 0
          })
        }
      })

      Object.keys(selectedPlaceRunners).forEach(key => {
        if (selectedPlaceRunners[key]) {
          var runner = selectedPlaceRunners[key]

          placeLegs.push({
            'IDTGRunner': runner.idtgrunner,
            'MeetingNumber': toteRp.meeting.number,
            'RaceNumber': toteRp.race.number,
            'RunnerNumber': runner.number,
            'RunnerName': runner.name,
            'IsFavourite': false,
            'IsField': false,
            'IsBanker': false,
            'LegOrder': 0,
            'Runner2FinishPlace': 0,
            'PoolLegNumber': 0
          })
        }
      })

      Object.keys(selectedShowRunners).forEach(key => {
        if (selectedShowRunners[key]) {
          var runner = selectedShowRunners[key]

          showLegs.push({
            'IDTGRunner': runner.idtgrunner,
            'MeetingNumber': toteRp.meeting.number,
            'RaceNumber': toteRp.race.number,
            'RunnerNumber': runner.number,
            'RunnerName': runner.name,
            'IsFavourite': false,
            'IsField': false,
            'IsBanker': false,
            'LegOrder': 0,
            'Runner2FinishPlace': 0,
            'PoolLegNumber': 0
          })
        }
      })

      if (toteRp && toteRp.pools && Array.isArray(toteRp.pools)) {
        let winPool = toteRp.pools.filter(item => item.type === 'WIN')[0] || undefined
        let placePool = toteRp.pools.filter(item => item.type === 'PLACE')[0] || undefined
        let showPool = toteRp.pools.filter(item => item.type === 'SHOW')[0] || undefined

        winIdTgPoolOffer = (winPool && winPool.id) || undefined
        placeIdTgPoolOffer = (placePool && placePool.id) || undefined
        showIdTgPoolOffer = (showPool && showPool.id) || undefined
      }

      if (winLegs.length > 0 && winIdTgPoolOffer) {
        tgBets.push({
          'IDTGBetType': 'NO_OPTION',
          'UnitStakeAmount': state.stake,
          'IDTGPoolType': 'WIN',
          'IDTGPoolOffer': winIdTgPoolOffer,
          'StakeAmount': 0,
          'NoOfCombinations': 0,
          'FractionalPercentage': null,
          'Legs': winLegs
        })
      }
      if (placeLegs.length > 0 && placeIdTgPoolOffer) {
        if (placeIdTgPoolOffer) {
          tgBets.push({
            'IDTGBetType': 'NO_OPTION',
            'UnitStakeAmount': state.stake,
            'IDTGPoolType': 'PLACE',
            'IDTGPoolOffer': placeIdTgPoolOffer,
            'StakeAmount': 0,
            'NoOfCombinations': 0,
            'FractionalPercentage': null,
            'Legs': placeLegs
          })
        }
      }
      if (showLegs.length > 0 && showIdTgPoolOffer) {
        if (showIdTgPoolOffer) {
          tgBets.push({
            'IDTGBetType': 'NO_OPTION',
            'UnitStakeAmount': state.stake,
            'IDTGPoolType': 'SHOW',
            'IDTGPoolOffer': showIdTgPoolOffer,
            'StakeAmount': 0,
            'NoOfCombinations': 0,
            'FractionalPercentage': null,
            'Legs': showLegs
          })
        }
      }
    }

    return tgBets
  },
  getPreparedRaceCastBets (context, request) {
    // request
    //   idtgpooltype - WIN, PLACE, DOUBLE...
    //   idtgpoolcategory - RUNNER POOL, RACECAST POOL, MULTIRACE POOL
    //   idtgrace - race id
    //   runner - runner objct
    //   pool - pool object
    //   type - STRAIGHT, BOX, KEY, KEYBOX
    //   order - KEY, WITH

    var toteRc = this.getters['raceState/getRaceRc']
    var tgBets = []
    var legs = []
    var idTgPoolOffer
    var betslipType = ''
    var selectedRunners

    switch (request.type) {
      case 'STRAIGHT': {
        selectedRunners = this.getters['betslipState/getSelectedRCStraightRunners']
        betslipType = 'STRAIGHT'

        if (selectedRunners.length > 0) {
          for (let i = 0; i < selectedRunners.length; i++) {
            Object.keys(selectedRunners[i]).forEach(key => {
              if (selectedRunners[i][key]) {
                let runner = selectedRunners[i][key]
                legs.push({
                  'IDTGRunner': runner.idtgrunner,
                  'MeetingNumber': toteRc.meeting.number,
                  'RaceNumber': toteRc.race.number,
                  'RunnerNumber': runner.number,
                  'RunnerName': runner.name,
                  'IsFavourite': false,
                  'IsField': false,
                  'IsBanker': false,
                  'LegOrder': i + 1,
                  'Runner2FinishPlace': i + 1,
                  'PoolLegNumber': 0
                })
              }
            })
          }
        }
        break
      }
      case 'BOX': {
        selectedRunners = this.getters['betslipState/getSelectedRCBoxRunners']
        betslipType = 'PERMUTATION'

        if (Object.keys(selectedRunners).length > 0) {
          let i = 0
          Object.keys(selectedRunners).forEach(key => {
            if (selectedRunners[key]) {
              let runner = selectedRunners[key]
              legs.push({
                'IDTGRunner': runner.idtgrunner,
                'MeetingNumber': toteRc.meeting.number,
                'RaceNumber': toteRc.race.number,
                'RunnerNumber': runner.number,
                'RunnerName': runner.name,
                'IsFavourite': false,
                'IsField': false,
                'IsBanker': false,
                'LegOrder': i + 1,
                'Runner2FinishPlace': 0,
                'PoolLegNumber': 0
              })
            }
            i++
          })
        }
        break
      }
      case 'KEY':
      case 'KEYBOX': {
        selectedRunners = request.type === 'KEY' ? this.getters['betslipState/getSelectedRCKeyRunners'] : this.getters['betslipState/getSelectedRCKeyBoxRunners']
        betslipType = request.type === 'KEY' ? 'BANKER' : 'FLOATING_BANKER'

        if (Object.keys(selectedRunners.key).length > 0 && Object.keys(selectedRunners.with).length > 0) {
          let i = 0
          Object.keys(selectedRunners.key).forEach(key => {
            let runner = selectedRunners.key[key]

            legs.push({
              'IDTGRunner': runner.idtgrunner,
              'MeetingNumber': toteRc.meeting.number,
              'RaceNumber': toteRc.race.number,
              'RunnerNumber': runner.number,
              'RunnerName': runner.name,
              'IsFavourite': false,
              'IsField': false,
              'IsBanker': true,
              'LegOrder': 1, // i + 1,
              'Runner2FinishPlace': 0,
              'PoolLegNumber': 0
            })

            i++
          })

          Object.keys(selectedRunners.with).forEach(key => {
            let runner = selectedRunners.with[key]

            legs.push({
              'IDTGRunner': runner.idtgrunner,
              'MeetingNumber': toteRc.meeting.number,
              'RaceNumber': toteRc.race.number,
              'RunnerNumber': runner.number,
              'RunnerName': runner.name,
              'IsFavourite': false,
              'IsField': false,
              'IsBanker': false,
              'LegOrder': 2, // i + 1,
              'Runner2FinishPlace': 0,
              'PoolLegNumber': 0
            })

            i = i + 1
          })
        }
      }
    }

    if (legs.length > 0) {
      if (toteRc.pools) {
        let pools = toteRc.pools.filter(pool => pool.type === request.idtgpooltype)

        idTgPoolOffer = (pools && pools[0] && pools[0].id) || null
      }

      tgBets.push({
        'IDTGBetType': betslipType,
        'UnitStakeAmount': state.stake,
        'IDTGPoolType': request.idtgpooltype,
        'IDTGPoolOffer': idTgPoolOffer,
        'StakeAmount': 0,
        'NoOfCombinations': 0,
        'FractionalPercentage': 0,
        'Legs': legs
      })
    }

    return tgBets
  },
  getPreparedMultiRaceBets (context, request) {
    // request
    //   idtgpooltype - WIN, PLACE, DOUBLE...
    //   idtgpoolcategory - RUNNER POOL, RACECAST POOL, MULTIRACE POOL
    //   idtgrace - race id
    //   runner - runner objct
    //   pool - pool object
    //   type - STRAIGHT, BOX, KEY, KEYBOX
    //   order - KEY, WITH

    var toteMr = this.getters['raceState/getToteMr']
    var tgBets = []
    var legs = []
    var idTgPoolOffer = request.pool.id
    var selectedRunners = this.getters['betslipState/getSelectedMRRunners']

    Object.keys(selectedRunners).forEach(idtgrace => {
      if (selectedRunners[idtgrace]) {
        let raceRunners = selectedRunners[idtgrace]
        let race = toteMr.meeting.races.filter(race => race.idtgrace.toString() === idtgrace.toString())[0]
        let legNumber = request.pool.legs.filter((leg) => {
          return leg.idtgrace.toString() === idtgrace.toString()
        })[0].number

        Object.keys(raceRunners).forEach(idtgrunner => {
          let runner = raceRunners[idtgrunner]

          legs.push({
            'IDTGRunner': runner.idtgrunner,
            'MeetingNumber': toteMr.meeting.number,
            'RaceNumber': race.number,
            'RunnerNumber': runner.number,
            'RunnerName': runner.name,
            'IsFavourite': false,
            'IsField': false,
            'IsBanker': false,
            'LegOrder': 0,
            'Runner2FinishPlace': 0,
            'PoolLegNumber': legNumber
          })
        })
      }
    })

    if (legs.length > 0) {
      tgBets.push({
        'IDTGBetType': 'NO_OPTION',
        'UnitStakeAmount': state.stake,
        'IDTGPoolType': request.idtgpooltype,
        'IDTGPoolOffer': idTgPoolOffer,
        'StakeAmount': 0,
        'NoOfCombinations': 0,
        'FractionalPercentage': 0,
        'Legs': legs
      })
    }

    return tgBets
  },
  calculateBetSlip (context, request) {
    // request
    //   idtgpooltype - WIN, PLACE, DOUBLE...
    //   idtgpoolcategory - RUNNER POOL, RACECAST POOL, MULTIRACE POOL
    //   idtgrace - race id
    //   runner - runner objct
    //   pool - pool object
    //   type - STRAIGHT, BOX, KEY, KEYBOX
    //   order - KEY, WITH

    if (state.stake) {
      switch (request.idtgpoolcategory) {
        case 'RUNNER POOL': {
          context.dispatch('getPreparedWinPLaceBets').then(result => {
            var tGateBets = result

            if (tGateBets.length > 0) {
              var betSlip = {
                'IsFree': false,
                'TGateBets': tGateBets,
                'Watermark': Date.now(),
                'IDMMPRVoucher': null,
                'IDMMPRHappyHour': null
              }

              lib.rpcService.callBroker('ToteBettingService', 'CalculateBetSlip', {betSlip: betSlip}).then(response => {
                context.commit('setCalculatedBets', (response.result && response.result.TGateBets) || [])
              }).catch((error) => {
                context.commit('setCalculatedBets', [])
                console.log('Bet calculation failed: ' + error.message)

                context.commit('setPlaceBetStatus', {
                  'StatusText': 'Bet calculation failed!',
                  'State': -2
                })
              })
            } else {
              context.commit('setCalculatedBets', [])
            }
          })

          break
        }
        // RACECAST POOLS
        case 'RACECAST POOL': {
          context.dispatch('getPreparedRaceCastBets', request).then(result => {
            var tGateBets = result

            if (tGateBets.length > 0) {
              var betSlip = {
                'IsFree': false,
                'TGateBets': tGateBets,
                'Watermark': Date.now(),
                'IDMMPRVoucher': null,
                'IDMMPRHappyHour': null
              }

              lib.rpcService.callBroker('ToteBettingService', 'CalculateBetSlip', {betSlip: betSlip}).then(response => {
                context.commit('setCalculatedBets', (response.result && response.result.TGateBets) || [])
              }).catch((error) => {
                context.commit('setCalculatedBets', [])
                console.error('Bet calculation failed: ' + error.message)

                context.commit('setPlaceBetStatus', {
                  'StatusText': 'Bet calculation failed!',
                  'State': -2
                })
              })
            } else {
              context.commit('setCalculatedBets', [])
            }
          })
          break
        }
        // MULTIRACE POOL
        case 'MULTIRACE POOL': {
          context.dispatch('getPreparedMultiRaceBets', request).then(result => {
            var tGateBets = result

            if (tGateBets.length > 0) {
              var betSlip = {
                'IsFree': false,
                'TGateBets': tGateBets,
                'Watermark': Date.now(),
                'IDMMPRVoucher': null,
                'IDMMPRHappyHour': null
              }

              lib.rpcService.callBroker('ToteBettingService', 'CalculateBetSlip', {betSlip: betSlip}).then(response => {
                context.commit('setCalculatedBets', (response.result && response.result.TGateBets) || [])
              }).catch((error) => {
                context.commit('setCalculatedBets', [])
                console.error('Bet calculation failed: ' + error.message)

                context.commit('setPlaceBetStatus', {
                  'StatusText': 'Bet calculation failed!',
                  'State': -2
                })
              })
            } else {
              context.commit('setCalculatedBets', [])
            }
          })
          break
        }
        default: {
          break
        }
      }
    } else {
      context.commit('setCalculatedBets', [])
    }
  },
  resetBetSlip (context) {
    context.commit('resetBetSlip')
  },
  resetBetslipStatus (context) {
    context.commit('resetBetslipStatus')
  },
  setStake (context, request) {
    // request
    //   idtgpooltype - WIN, PLACE, DOUBLE...
    //   idtgpoolcategory - RUNNER POOL, RACECAST POOL, MULTIRACE POOL
    //   idtgrace - race id
    //   runner - runner objct
    //   pool - pool object
    //   type - STRAIGHT, BOX, KEY, KEYBOX
    //   order - KEY, WITH

    context.commit('setStake', request.value)
    this.dispatch('betslipState/calculateBetSlip', request)
  },
  placeBet (context) {
    var self = this
    var calculatedBets = this.getters['betslipState/getCalculatedBets']
    var isLoggedIn = this.getters['isLoggedIn']
    var stake = this.getters['betslipState/getStake']

    if (isLoggedIn) {
      if (calculatedBets && calculatedBets.length > 0 && stake) {
        var betSlip = {
          'IsFree': false,
          'TGateBets': calculatedBets,
          'IDMMPRVoucher': null,
          'IDMMPRHappyHour': null,
          'Watermark': null
        }

        context.commit('setPlaceBetStatus', {
          'StatusText': 'Placing bet...',
          'State': 0
        })

        lib.rpcService.callBroker('ToteBettingService', 'PlaceTGateBetSlip', {betSlip: betSlip}).then(response => {
          if (response && response.result && response.result.IDTGBetSlip) {
            self.dispatch('betslipState/startBetsPlacementStatusCheck', response.result.IDTGBetSlip)
          } else if (response && response.result && response.result.Status) {
            context.commit('setPlaceBetStatus', response.result.Status)
          } else {
            context.commit('setPlaceBetStatus', {
              'StatusText': 'Unknown error occured!',
              'State': -1
            })
          }
        }).catch(error => {
          console.log(error)

          context.commit('setPlaceBetStatus', {
            'StatusText': 'Unknown error occured!',
            'State': -1
          })
        })
      }
    } else {
      context.commit('setPlaceBetStatus', {
        'StatusText': 'Please login to place bet!',
        'State': -10
      })
    }
  },
  startBetsPlacementStatusCheck (context, idtgbetslip) {
    var self = this

    lib.rpcService.callBroker('ToteBettingService', 'GetTGatePlacementState', { IDTGBetSlip: idtgbetslip }).then(response => {
      // if (response && response.result && response.result.BetResults && response.result.BetResults.length > 0) {
      //   context.commit('setPlacedBets', response.result.BetResults)
      // }

      if (response.result === 'L') {
        context.commit('setPlaceBetStatus', 'L')

        setTimeout(() => {
          self.dispatch('betslipState/startBetsPlacementStatusCheck', idtgbetslip)
        }, 1000)
      } else {
        context.commit('setPlaceBetStatus', response.result)
      }
    }).catch(error => {
      console.log(error)

      context.commit('setPlaceBetStatus', {
        'StatusText': 'Unknown error occured!',
        'State': -1
      })
    })
  }
}

const mutations = {
  toggleSelectedWinRunners (state, runner) {
    if (state.selectedWinRunners[runner.idtgrunner]) {
      Vue.delete(state.selectedWinRunners, runner.idtgrunner)
    } else {
      Vue.set(state.selectedWinRunners, runner.idtgrunner, runner)
    }
  },
  toggleSelectedPlaceRunners (state, runner) {
    if (state.selectedPlaceRunners[runner.idtgrunner]) {
      Vue.delete(state.selectedPlaceRunners, runner.idtgrunner)
    } else {
      Vue.set(state.selectedPlaceRunners, runner.idtgrunner, runner)
    }
  },
  toggleSelectedShowRunners (state, runner) {
    if (state.selectedShowRunners[runner.idtgrunner]) {
      Vue.delete(state.selectedShowRunners, runner.idtgrunner)
    } else {
      Vue.set(state.selectedShowRunners, runner.idtgrunner, runner)
    }
  },
  toggleSelectedRCStraightRunners (state, request) {
    if (state.selectedRCStraightRunners[request.order - 1] && state.selectedRCStraightRunners[request.order - 1][request.runner.idtgrunner]) {
      Vue.delete(state.selectedRCStraightRunners[request.order - 1], request.runner.idtgrunner)
    } else {
      for (let i = 0; i < state.selectedRCStraightRunners.length; i++) {
        if (state.selectedRCStraightRunners[i] && state.selectedRCStraightRunners[i].hasOwnProperty(request.runner.idtgrunner)) {
          Vue.delete(state.selectedRCStraightRunners[i], request.runner.idtgrunner)
        }
      }
      Vue.set(state.selectedRCStraightRunners, request.order - 1, {})
      Vue.set(state.selectedRCStraightRunners[request.order - 1], request.runner.idtgrunner, request.runner)
    }
  },
  toggleSelectedRCBoxRunners (state, runner) {
    if (state.selectedRCBoxRunners[runner.idtgrunner]) {
      Vue.delete(state.selectedRCBoxRunners, runner.idtgrunner)
    } else {
      Vue.set(state.selectedRCBoxRunners, runner.idtgrunner, runner)
    }
  },
  toggleSelectedRCKeyRunners (state, request) {
    if (state.selectedRCKeyRunners[request.order][request.runner.idtgrunner]) {
      Vue.delete(state.selectedRCKeyRunners[request.order], request.runner.idtgrunner)
    } else {
      if (request.order === 'key') {
        // Vue.set(state.selectedRCKeyRunners, 'key', {})
        Vue.delete(state.selectedRCKeyRunners.with, request.runner.idtgrunner)
        Vue.set(state.selectedRCKeyRunners.key, request.runner.idtgrunner, request.runner)
      } else if (request.order === 'with') {
        Vue.delete(state.selectedRCKeyRunners.key, request.runner.idtgrunner)
        Vue.set(state.selectedRCKeyRunners.with, request.runner.idtgrunner, request.runner)
      }
    }
  },
  toggleSelectedRCKeyBoxRunners (state, request) {
    if (state.selectedRCKeyBoxRunners[request.order][request.runner.idtgrunner]) {
      Vue.delete(state.selectedRCKeyBoxRunners[request.order], request.runner.idtgrunner)
    } else {
      if (request.order === 'key') {
        // Vue.set(state.selectedRCKeyBoxRunners, 'key', {})
        Vue.delete(state.selectedRCKeyBoxRunners.with, request.runner.idtgrunner)
        Vue.set(state.selectedRCKeyBoxRunners.key, request.runner.idtgrunner, request.runner)
      } else if (request.order === 'with') {
        Vue.delete(state.selectedRCKeyBoxRunners.key, request.runner.idtgrunner)
        Vue.set(state.selectedRCKeyBoxRunners.with, request.runner.idtgrunner, request.runner)
      }
    }
  },
  toggleSelectedMRRunners (state, request) {
    if (!state.selectedMRRunners[request.idtgrace]) {
      Vue.set(state.selectedMRRunners, request.idtgrace, {})
    }

    if (state.selectedMRRunners[request.idtgrace] && state.selectedMRRunners[request.idtgrace][request.runner.idtgrunner]) {
      Vue.delete(state.selectedMRRunners[request.idtgrace], request.runner.idtgrunner)
      if (Object.keys(state.selectedMRRunners[request.idtgrace]).length === 0) {
        Vue.delete(state.selectedMRRunners, [request.idtgrace])
      }
    } else {
      Vue.set(state.selectedMRRunners[request.idtgrace], request.runner.idtgrunner, request.runner)
    }
  },
  toggleBetslip (state) {
    state.showBetSlip = !state.showBetSlip
  },
  resetBetSlip (state) {
    state.selectedWinRunners = {}
    state.selectedPlaceRunners = {}
    state.selectedShowRunners = {}
    state.selectedRCStraightRunners = [{}, {}, {}, {}]
    state.selectedRCBoxRunners = {}
    state.selectedRCKeyRunners = {key: {}, with: {}}
    state.selectedRCKeyBoxRunners = {key: {}, with: {}}
    state.selectedMRRunners = { }
    state.betslipType = ''
    state.stake = 0
    state.calculatedBets = []
    state.placeBetStatus = ''
  },
  resetBetslipStatus (state) {
    state.placeBetStatus = ''
  },
  setCalculatedBets (state, value) {
    state.calculatedBets = value
  },
  setStake (state, value) {
    state.stake = value ? parseFloat(value) : 0
  },
  setPlaceBetStatus (state, value) {
    state.placeBetStatus = value || ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/betslip.js